/**
 * Sale response from `get_sale_by_id` endpoint.
 * Maps the backend SaleWeb DTO shape.
 * Note: numeric amounts come as strings from the backend.
 */
export interface SaleResponse {
  id: string;
  detail: string;
  quantity: number;
  email: string;
  client: string;
  event: string;
  date: string | null;
  hour: string | null;
  image: string | null;
  identificador: number;
  stateDesc: string;
  state: number;
  price: string;
  /** SUBTOTAL en DÓLARES, SIN comisión (backend: getSubtotal()). NO usar para cobrar. */
  amount: string;
  /** Total REAL a cobrar en DÓLARES, precio + comisión (backend: getTotal()). Lo cobran Plux, PayPhone y la App. */
  total: string;
  tax: string;
  /** Amount before tax (for PayPhone). */
  amountbp: string;
  /** Total for PayPhone. */
  totalpb: string;
  /** Tax for PayPhone. */
  taxpb: string;
  iva: string;
  metodoPago: string;
  /** PayPhone store ID (if available). */
  storeId?: string;
  /** PayPhone reference. */
  reference?: string;
  /** PayPhone client transaction ID. */
  clientTransactionId?: string;
  /**
   * Estado de pago textual del backend: APROBADO, PENDIENTE, RECHAZADO, EXPIRADO, ANULADO.
   *
   * RF-3 (bug-20261001-venta-cerrada-se-lee-como-pagada). Opcional porque una respuesta vieja
   * —o una venta anterior al cambio— puede no traerlo; `state` queda como respaldo.
   *
   * Es lo ÚNICO que distingue una venta expirada de una rechazada: las dos son `state = 2`.
   */
  estadoPago?: string;
}

/**
 * Request to create a sale via `save_sale`.
 * Matches what the backend expects.
 */
export interface SaveSaleRequest {
  id: number;
  cantidad: number;
  email: string;
  pago: number;
  origen?: string;
  whatsapp?: string;
  seats?: string;
  cedula?: string;
  nombre?: string;
  user?: {
    name: string;
    email: string;
    phone: string;
    address: string;
    uuid: string;
  };
}

/** Payment method code mapping for the backend. */
export const PAYMENT_METHOD_CODES = {
  PAYPHONE: 1,
  EFECTIVO: 2,
  PLACE_TO_PAY: 3,
  DEUNA: 4,
  GRATIS: 5,
  JEP: 6,
  COOPERCO: 7,
  PLUX: 8,
} as const;

export type PaymentMethodCode =
  (typeof PAYMENT_METHOD_CODES)[keyof typeof PAYMENT_METHOD_CODES];
